import Naluri from '~/common/api/naluri';
import {
  CHAT_REMOVE_CHAT_BOOKMARK_BEGIN,
  CHAT_REMOVE_CHAT_BOOKMARK_SUCCESS,
  CHAT_REMOVE_CHAT_BOOKMARK_FAILURE,
  CHAT_REMOVE_CHAT_BOOKMARK_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function removeChatBookmark(messageIds) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: CHAT_REMOVE_CHAT_BOOKMARK_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const params = {
        bookmarks: {
          message_ids: messageIds,
        },
      };
      const doRequest = Naluri.delete(`/api/bookmarks`, params);
      doRequest.then(
        res => {
          dispatch({
            type: CHAT_REMOVE_CHAT_BOOKMARK_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: CHAT_REMOVE_CHAT_BOOKMARK_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissRemoveChatBookmarkError() {
  return {
    type: CHAT_REMOVE_CHAT_BOOKMARK_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CHAT_REMOVE_CHAT_BOOKMARK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        removeChatBookmarkPending: true,
        removeChatBookmarkError: null,
      };

    case CHAT_REMOVE_CHAT_BOOKMARK_SUCCESS:
      // The request is success
      const messageIds = action.data.message_ids;
      let newState = state.starredMessages;

      if (messageIds.length < 2) {
        newState = newState.remove(messageIds[0]);
      } else {
        messageIds.forEach(message => {
          newState = newState.remove(message);
        });
      }
      return {
        ...state,
        starredMessages: newState,
        removeChatBookmarkPending: false,
        removeChatBookmarkError: null,
      };

    case CHAT_REMOVE_CHAT_BOOKMARK_FAILURE:
      // The request is failed
      return {
        ...state,
        removeChatBookmarkPending: false,
        removeChatBookmarkError: action.data.error,
      };

    case CHAT_REMOVE_CHAT_BOOKMARK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        removeChatBookmarkError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/chat/redux/removeChatBookmark.js